import { UTurnLeftSharp } from '@mui/icons-material';

export const faq = {
  title: 'Frequently Asked Questions',
  subtitle: 'Find Answers to Your Most Common Questions',
};

export const faqList = [
  {
    title: 'About CashClever',
    questions: [
      {
        question: 'What is CashClever?',
        answer:
          'CashClever is a lending marketplace that helps consumers connect with auto and mortgage lenders. We provide tailored recommendations based on your financial profile to help you find the best loan options.',
      },
      // {
      //   question: 'How are we different from our competitors?',
      //   answer:
      //     'Unlike other platforms, CashClever personalizes loan recommendations to fit your unique needs. We analyze your financial information and match you with lenders who offer the best terms for you. Plus, we don’t charge you any fees—our earnings come from the lender only.',
      // },
      {
        question: 'How much does it cost to check rates on CashClever?',
        answer:
          'It’s completely free to check rates and see the personalized rate options available for each lender. There are no fees for consumers.',
      },
      {
        question: 'How do we make money?',
        answer:
          'There will be various ways for CashClever to make money where we will be working with lenders for various affliate programs such as referral bonuses and various PPC programs.',
      },
      {
        question: 'How does CashClever protect consumer data and privacy?',
        answer:
          'CashClever uses top-tier encryption and security protocols to ensure that your personal information is always safe and protected.',
      },
      {
        question: 'What are your closing costs?',
        answer:
          "CashClever, at this time, does not provide mortgage loans directly on the platform. Any fees you may encounter are will be based on the lender's terms.",
      },
      {
        question: 'In what region or states does CashClever operate?',
        answer: "CashClever provides lenders' rates all over United States of America.",
      },
      // {
      //   question: 'How can I change the information I submitted on my loan request?',
      //   answer:
      //     'You can easily update your loan request by logging into your account and editing your information.',
      // },
    ],
  },
  {
    title: 'Credit Related',
    questions: [
      {
        question: 'What would be the impact on my credit score?',
        answer:
          'Checking loan rates through CashClever will not impact your credit score. If you proceed with an application, lenders may perform a hard inquiry, which could affect your score slightly.',
      },
      {
        question: 'Is there any minimum credit score limit to get pre-qualified for the loan?',
        answer:
          "CashClever doesn't impose a minimum credit score. However, different lenders have their own criteria, and some may require a certain credit score to offer you a loan.",
      },
    ],
  },
  {
    title: 'Account Related',
    questions: [
      {
        question: 'How can I reset my CashClever password?',
        answer:
          'To reset your password, simply click on the "Forgot Password" link on the login page and follow the instructions.',
      },
      {
        question: 'How do I delete my account with CashClever?',
        answer:
          'You can delete your account by contacting our support team through email or our website’s support page. We’ll assist you with the process.',
      },
      {
        question: 'How do I update my account details?',
        answer: 'Log in to your CashClever account and go to "Profile" to update your details.',
      },
      {
        question: 'How do I connect with a support representative?',
        answer: (
          <span>
            You can reach our support team by emailing
            <a href="mailto:info@cashclever.com"> info@cashclever.com </a>
            or visiting our "Contact Us" page for additional contact options.
          </span>
        ),
      },
    ],
  },
  {
    title: 'Auto Related',
    questions: [
      {
        question: 'What is an auto loan?',
        answer:
          'An auto loan helps you finance the purchase of a vehicle. You repay the loan in installments over a set period.',
      },
      {
        question: 'Does this auto loan lending information apply to both used and new vehicles?',
        answer:
          'Currently, CashClever offers loans for used vehicles. We will soon offer loans for new vehicles as well.',
        answer:
          "CashClever provides lenders' financing rates for both new and used vehicles and you can apply for the loan on the lenders' platform directly.",
      },
      {
        question:
          'Does CashClever provide informational rates for all types of vehicles, or just cars and light trucks?',
        answer:
          "At the moment, CashClever focuses on cars and light trucks. We plan to expand to providing lenders' rates for other types of vehicles in the future.",
      },
      {
        question: 'Do I need a cosigner?',
        answer:
          'A cosigner may be required depending on the lender’s requirements and your financial situation. However, it’s not mandatory for everyone.',
      },
      {
        question: 'How does the auto loan application process work?',
        answer:
          "We provide personalized loan rates for lenders based on your searched criteria. You then can apply for auto loans by providing your personal and financial information on the lenders' platform directly.",
      },
      {
        question: 'What information do I need to apply for an auto loan?',
        answer:
          'You’ll need to provide personal details, employment information, income, and the vehicle details (for used vehicles).',
      },
      {
        question: 'Can I refinance my current auto loan through this platform?',
        answer:
          "You can search for the best re-financing auto rates and apply to refinance your current auto loan through the lenders' platform directly potentially secure better terms.",
      },
      {
        question: 'Are there any fees when applying for an auto loan?',
        answer:
          'There are no fees to apply for an auto loan through CashClever. Any fees, if applicable, will come from the lender.',
      },
    ],
  },

  {
    title: 'Mortgage Related',
    questions: [
      {
        question: 'What types of mortgage loans can I apply for?',
        answer:
          'You can apply for various mortgage loan types, such as fixed-rate and adjustable-rate mortgages, personalized to your financial situation.',
      },
      {
        question: 'How do I apply for a mortgage loan on this platform?',
        answer:
          'CashClever currently at this time does not provide mortgage loans directly, we provide mortgage rates of the lenders and you can apply directly on their platform.',
      },
      {
        question: 'What documents do I need to apply for a mortgage?',
        answer:
          'Typically, you’ll need proof of income, identification, and credit history. The required documents may vary by lender.',
      },
      {
        question: 'How do I know if I qualify for a mortgage loan?',
        answer:
          "Search through the mortgage rates filter to see the rates available and apply for mortgage loans directly on the lenders' platform.",
      },
      {
        question: 'What are the interest rates for mortgage loans on this platform?',
        answer:
          'Mortgage rates vary depending on the lender and your financial profile. You can view customized rates by submitting your information on CashClever.',
      },
      {
        question: 'Are there any fees involved in applying for a mortgage?',
        answer:
          'CashClever charges no fees. Any applicable fees will be charged by the lender after you proceed with the loan application.',
      },
    ],
  },
  // {
  //   title: 'Homeowners Insurance',
  //   questions: [
  //     {
  //       question: 'What is homeowners insurance?',
  //       answer:
  //         'Homeowners insurance helps protect your home and personal property from damages caused by events such as fire, theft, vandalism, or natural disasters.',
  //     },
  //     {
  //       question: 'What does homeowners insurance cover?',
  //       answer: (
  //         <ul className="home-owners-insurance-list-items">
  //           <li className="list-style-tags">
  //             <b> • Dwelling Coverage: </b> Covers damage to your home structure.
  //           </li>
  //           <li className="list-style-tags">
  //             <b> • Personal Property Coverage: </b> Protects your belongings (e.g., furniture,
  //             electronics).
  //           </li>
  //           <li className="list-style-tags">
  //             <b> • Liability Coverage: </b> Covers accidents and injuries that occur on your
  //             property.
  //           </li>
  //           <li className="list-style-tags">
  //             <b> • Additional Living Expenses (ALE): </b> Covers living costs if your home is
  //             uninhabitable due to damage.
  //           </li>
  //           <li className="list-style-tags">
  //             <b> • Flood and Earthquake Insurance:</b> May be separate, depending on your location.
  //           </li>
  //         </ul>
  //       ),
  //     },
  //     {
  //       question: 'How much homeowners insurance coverage do I need?',
  //       answer:
  //         'The amount of coverage you need depends on the value of your home, the cost of rebuilding, and the value of your personal belongings. A CashClever insurance expert can help you determine the right coverage.',
  //     },
  //     {
  //       question: 'What factors affect my homeowners insurance premiums?',
  //       answer: (
  //         <ul className="home-owners-insurance-list-items">
  //           <li className="list-style-tags"> • Home value and location </li>
  //           <li className="list-style-tags"> • Deductible amount </li>
  //           <li className="list-style-tags"> • Claims history </li>
  //           <li className="list-style-tags"> • Age and condition of the home </li>
  //           <li className="list-style-tags">
  //             {' '}
  //             • Type of coverage and additional options (e.g., flood insurance){' '}
  //           </li>
  //           <li className="list-style-tags"> • Credit history (in some states) </li>
  //         </ul>
  //       ),
  //     },
  //     {
  //       question: 'Can I get homeowners insurance for a second home or rental property?',
  //       answer:
  //         'Yes, you can get homeowners insurance for both second homes and rental properties. The coverage may differ from standard homeowners insurance, depending on the property’s usage.',
  //     },
  //     {
  //       question: 'Are there discounts available for homeowners insurance?',
  //       answer:
  //         'Yes, discounts may be available for home security systems, bundling with other policies (e.g., auto), loyalty discounts, and claims-free histories.',
  //     },
  //     {
  //       question: 'How do I get a quote for homeowners insurance?',
  //       answer:
  //         'You can receive a personalized quote by submitting details about your property, coverage preferences, and location through the CashClever platform. We’ll connect you with trusted insurance providers.',
  //     },
  //     // {
  //     //   question: 'Can I make changes to my homeowners insurance policy?',
  //     //   answer:
  //     //     'Yes, you can adjust your coverage, update personal details, or add additional coverage options anytime by contacting your provider or through CashClever.',
  //     // },
  //     {
  //       question: 'Does CashClever offer homeowners insurance?',
  //       answer:
  //         'CashClever will be partnering with leading insurance companies to offer competitive homeowners insurance quotes. This will enable consumers with multiple options to make informed decisions.',
  //     },
  //   ],
  // },
  {
    title: 'Federal Credit Unions',
    questions: [
      {
        question: 'What are Federal Credit Unions?',
        answer:
          'Not-For-Profit financial institutions charted and regulated by the US Federal Government. Designed to serve their members rather than generate profits for shareholders.',
      },
      {
        question: 'What are key features of Federal Credit Union?',
        answer: (
          <ul className="home-owners-insurance-list-items">
            <li className="list-style-tags">
              <b> • Member Owned: </b> When you join, you become a part-owner.
            </li>
            <li className="list-style-tags">
              <b>• Non-Profit Structure: </b> Earnings are returned to members through lower rates,
              higher savings rates, and fewer fees.
            </li>
            <li className="list-style-tags">
              <b> • Federally Chartered: </b> They're created under federal law and regulated by the
              National Credit Union Administration.
            </li>
            <li className="list-style-tags">
              <b> • Insured Deposits: </b> Member deposits are protected up to $250,000 by the
              National Credit Union Share Insurance Fund, similar to FDIC insurance for banks.
            </li>
          </ul>
        ),
      },
      {
        question: 'How do Federal Credit Unions differ from larger banks?',
        answer:
          'Banks are For-Profit companies owned by shareholders whereas Federal Credit Unions are cooperatives focused on serving members.',
      },
      {
        question: 'What are the various ways to qualify to be a member?',
        answer: (
          <ul className="home-owners-insurance-list-items">
            <li className="list-style-tags"> • Employer or Industry</li>
            <li className="list-style-tags"> • Geographic Area </li>
            <li className="list-style-tags"> • Membership in a specific organization </li>
            {/* <li className="list-style-tags"> • Age and condition of the home </li>
            <li className="list-style-tags">
              {' '}
              • Type of coverage and additional options (e.g., flood insurance){' '}
            </li>
            <li className="list-style-tags"> • Credit history (in some states) </li> */}
          </ul>
        ),
      },
      {
        question: 'How much do you save on Auto Loans with Federal Credit Unions?',
        answer:
          'On average, Federal Credit Unions tend to offer loan rates 0.5% to 2.0% lower than large banks. The exact gap depends on credit score, loan term and market conditions.',
      },
      {
        question:
          'What are some examples when the potential in savings larger at Federal Credit Unions?',
        answer: 'Fair or rebuilding credit, older used vehicles, and longer loan terms.',
      },
      {
        question: 'How much do you save on Mortage Loans with Federal Credit Unions?',
        answer:
          'On average, Federal Credit Unions provide about 0.1% to 0.5% lower APR compared to large banks.',
      },
      // {
      //   question: 'Can I make changes to my homeowners insurance policy?',
      //   answer:
      //     'Yes, you can adjust your coverage, update personal details, or add additional coverage options anytime by contacting your provider or through CashClever.',
      // },
      {
        question:
          'What are some examples where the Mortgage Loan savings widen even more at Federal Credit Unions?',
        answer:
          'Members who build stronger relationships with Credit Unions, doing Jumbo Loan, ARM, or portfolio loan as well as First Time Homebuyers using in-hour programs.',
      },
    ],
  },
  {
    title: 'General Insurance-Related FAQs',
    questions: [
      {
        question: 'How can I compare auto and homeowners insurance quotes?',
        answer:
          'CashClever allows you to compare multiple insurance quotes by entering your preferences and information in our platform. We’ll provide personalized recommendations based on your needs.',
      },
      {
        question: 'Do I need separate insurance for my car and home?',
        answer:
          'Yes, auto and homeowners insurance are separate policies, but you can often save by bundling them with the same provider. CashClever can help you find bundled discounts.',
      },
      {
        question: 'Is it possible to switch my current insurance provider through CashClever?',
        answer:
          "You can compare options and switch your current insurance provider to one you like on the provider's platform directly. We make it easy to find better deals and manage your policies.",
      },
      {
        question: 'How do I file a claim with my insurance provider?',
        answer:
          'To file a claim, contact your insurance provider directly or use their online platform. If you need assistance, CashClever can help guide you through the claims process.',
      },
    ],
  },
];
